module.exports = __webpack_public_path__ + "img/bottom_tree_004.f0a2563c.svg";